// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__FRf20","mltShdSpin":"loader_mltShdSpin__d-liF","round":"loader_round__8t+av"};